<template>
  <b-row>
    <b-col sm="12">
      <b-input-group prepend="Titulo" size="sm" class="mt-4">
        <b-form-input
          v-bind:value="title"
          v-on:input="(event) => this.$emit('update:title', event)"
          v-validate.initial="'required'"
          type="text"
          name="title"
          size="sm"
          :disabled="disabledInputs"
        />
      </b-input-group>
      <b-form-invalid-feedback
        :state="errors.collect('title').length === 0"
      >{{errors.first('title')}}</b-form-invalid-feedback>
    </b-col>
    <b-col sm="12">
      <b-input-group prepend="Subtitle" size="sm" class="mt-4">
        <b-form-input
          v-bind:value="subtitle"
          v-on:input="(event) => this.$emit('update:subtitle', event)"
          v-validate.initial="'required'"
          type="text"
          name="subtitle"
          size="sm"
          :disabled="disabledInputs"
        />
      </b-input-group>
      <b-form-invalid-feedback
        :state="errors.collect('subtitle').length === 0"
      >{{errors.first('subtitle')}}</b-form-invalid-feedback>
    </b-col>
    <b-col sm="12">
      <b-input-group prepend="Descriçao" size="sm" class="mt-4">
        <b-form-textarea
          v-bind:value="description"
          v-on:input="(event) => this.$emit('update:description', event)"
          v-validate.initial="'required'"
          type="text"
          name="description"
          size="lg"
          :disabled="disabledInputs"
          rows="3"
          max-rows="8"
        />
      </b-input-group>
      <b-form-invalid-feedback
        :state="errors.collect('description').length === 0"
      >{{errors.first('description')}}</b-form-invalid-feedback>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "translationMenu",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    disabledInputs: {
      type: Boolean,
      required: true
    }
  }
};
</script>